import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';
import {
  LOAD_ASSESSMENT_LIST,
  LOAD_ASSESSMENT_LIST_SUCCESS,
  LOAD_ASSESSMENT_LIST_ERROR,
  RESET_ASSESSMENT_LIST,
} from '../type';

const packageReducer = handleActions(
  new Map([
    [
      LOAD_ASSESSMENT_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            assessmentListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_ASSESSMENT_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            assessmentListLoading: { $set: false },
          },
          assessmentList: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_ASSESSMENT_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            assessmentListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    [
      RESET_ASSESSMENT_LIST,
      (state, action) => {
        return update(state, {
          assessmentList: { $set: [] },
        });
      },
    ],
  ]),
  initialState,
);
export default packageReducer;
